<template>
  <div
    :class="(isDisabled ? 'bg-gray-600 text-white shadow-gray cursor-default' : 'group '+typeShadow+' '+textColor+' '+bgColor+' '+borderColor+' '+bgColorHover+' '+typeShadowHover) + ' flex items-center min-w-max-content w-max min-w-max group border '+padding+' leading-4 rounded-md focus:outline-none transition ease-in-out duration-300 transform hover:scale-110 cursor-pointer relative'"
    :disabled="isDisabled"
  >
    <div
      v-if="enableAction"
      @click.stop="$emit('clickAction')"
      class="absolute w-full h-full left-0 top-0 z-10"
    />
    <div
      v-if="!right && (icon != null || (spinner && resp && $isMobile()))"
      :class="(isDisabled ? 'text-white bg-gray-600' : iconColor+' '+bgColorSquare+' '+bgColorSquareHover) + ' inline-flex '+(isSmall ? 'px-1 py-0.5' : 'p-2 md:p-1 xl:p-2')+' sm:w-auto leading-4 border border-transparent rounded-md transition ease-in-out duration-150'"
    >
      <span
        v-if="spinner && resp && $isMobile() "
        class="h-3 w-3 xxl:h-4 xxl:w-4 2xl:h-5 2xl:w-5 spinner"
      />
      <icon
        v-else
        :name="icon"
        :class="{'h-3 w-3 xl:h-3 xl:w-3 xxl:h-4 xxl:w-4 2xl:h-5 2xl:w-5':!isSmall,
                 'h-3 w-3 xl:h-3 xl:w-3 xxl:h-4 xxl:w-4 2xl:h-5 2xl:w-5':isSmall,
                 'transform -rotate-180' : flipY}"
      />
    </div>
    <p
      class="w-full text-center flex"
      :class="{'hidden md:block':icon && resp || resp && $isMobile(), 'mx-3' : !onboarding, 'ml-3 mr-2': onboarding}"
    >
      <span :class="sizeText+(uppercase ? ' uppercase' : '')">{{ libelle }}</span>
      <span
        v-if="spinner && icon == null && !right"
        class="spinner bottom-2 mx-2"
      />
    </p>
    <div
      v-if="right && (icon != null || spinner)"
      :class="(isDisabled ? 'text-white bg-gray-600' : iconColor+' '+bgColorSquare+' '+bgColorSquareHover) + ' relative inline-flex '+(isSmall ? 'px-1 py-0.5' : 'p-2')+'  sm:w-auto leading-4 border border-transparent rounded-md transition ease-in-out duration-300 transform hover:scale-110'"
    >
      <span
        v-if="spinner"
        class="h-3 w-3 xxl:h-4 xxl:w-4 2xl:h-5 2xl:w-5 spinner"
      />
      <icon
        v-else
        :name="icon"
        :class="(isSmall ? 'h-3 w-3 xl:h-3 xl:w-3 xxl:h-4 xxl:w-4 2xl:h-5 2xl:w-5' : 'h-3 w-3 xl:h-3 xl:w-3 xxl:h-4 xxl:w-4 2xl:h-5 2xl:w-5') + (flipY ? ' transform -rotate-180' : '')"
      />
    </div>
  </div>
</template>

<script>

import Icon from './Icon';

export default {
  props: {
    isDisabled: {
      type: Boolean,
      required:false,
      default: false
    },
    disabledTooltip: {
      type: String,
      required: false,
      default: '',
    },
    onboarding: {
      type: Boolean,
      default: false,
      required: false,
    },
    borderColor: String,
    textColor: String,
    bgColor: String,
    bgColorHover: String,
    iconColor: String,
    bgColorSquare: String,
    bgColorSquareHover: String,
    libelle: String,
    icon: String,
    right: Boolean,
    spinner: Boolean,
    responsive: Boolean,
    typeShadow: String,
    typeShadowHover: String,
    textSize: String,
    uppercase:{
      type: Boolean,
      required:false,
      default: false,
    },
    isSmall:{
      type: Boolean,
      required: false,
      default: false,
    },
    enableAction:{
      type: Boolean,
      required: false,
      default: true,
    },
    flipY: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  components:{
    Icon,
  },
  data(){
    return{
      resp: false,
      padding: 'p-0.5',
      sizeText: 'text-sm',
      displayToolTip: false
    };
  },
  mounted(){
    // minimize when smaller screen ?
    if(this.responsive){
      this.resp = true;
    }

    //In case there isn't icon
    if(!this.icon || this.icon == null || this.icon == undefined || this.icon == ''){
      this.padding = this.isSmall ? 'px-1 py-1' : 'px-2 py-3';
    }

    if(this.textSize && this.textSize != null && this.textSize != undefined && this.textSize != ''){
      this.sizeText = this.textSize;
    }

  },

  methods:{
    clickMethod (event) {
      if (this.$emit('clickAction')) {
        event.stopPropagation();
      }
    }
  }
};
</script>
